module.exports = __webpack_public_path__ + "img/edge_divers_webcam.fa2cdfca.svg";